import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

const FORBIDDEN_FILE_NAME_PATTERN = /[/\\?#%\p{Cc}]|\.\.|\.\s*$/u;

export const forbiddenFileNameValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value: unknown = control.value;

  if (typeof value !== 'string') {
    return null;
  }

  return FORBIDDEN_FILE_NAME_PATTERN.test(value) ? {forbiddenFileName: true} : null;
};

export function fileExtensionValidator(originalFileName: string): ValidatorFn {
  const separatorIndex: number = originalFileName.lastIndexOf('.');
  const originalExtension: string =
    separatorIndex < 0 ? '' : originalFileName.slice(separatorIndex);
  const extension: string = originalExtension.toLowerCase();

  return (control: AbstractControl): ValidationErrors | null => {
    const value: unknown = control.value;

    if (typeof value !== 'string') {
      return null;
    }

    const trimmedFileName: string = value.trim();
    const fileName: string = trimmedFileName.toLowerCase();

    return fileName.endsWith(extension) ? null : {fileExtension: true};
  };
}
